import {FontAwesomeIcon} from '../types/icon.types'
import {FontAwesomeFieldsFragment} from '../../../../__generated__/datocms.types'

export function parseFontAwesomeIcon(icon: FontAwesomeFieldsFragment): FontAwesomeIcon {
  return {
    name: icon.name!,
    collection: icon.collection!,
  }
}
